import BigNumber from "bignumber.js";
export function serializeBitcoinTransaction({ family, amount, recipient, feePerByte, opReturnData, }) {
    return {
        family,
        amount: amount.toString(),
        recipient,
        feePerByte: feePerByte?.toString(),
        opReturnDataHex: opReturnData?.toString("hex"),
    };
}
export function deserializeBitcoinTransaction({ family, amount, recipient, feePerByte, opReturnDataHex, }) {
    return {
        family,
        amount: new BigNumber(amount),
        recipient,
        feePerByte: feePerByte ? new BigNumber(feePerByte) : undefined,
        opReturnData: opReturnDataHex
            ? Buffer.from(opReturnDataHex, "hex")
            : undefined,
    };
}
//# sourceMappingURL=serializer.js.map